module.exports = __webpack_public_path__ + "static/img/DM.2e14f656.svg";